import API_URL from "@/globals/api";

/**
 * Where the Stripe endpoints live.
 *
 * They used to be a standalone service on its own hostname (:4242 locally, a
 * Cloud Run URL in production). They are now part of the main backend, so the
 * host is derived from globals/api.js — the single source of truth — and
 * ?backend=nextjs|laravel|local switches these along with everything else.
 *
 * Only stripe.service.js should need this: every endpoint under it requires an
 * Authorization header, so the call has to go through the shared axios instance
 * rather than being pasted into an <a href> or window.location.
 */
export const STRIPE_API_URL = `${API_URL}/stripe`;

// Crypto payment provider — switch between Heleket and Cryptomus by commenting/uncommenting
const CRYPTO_URL = window.location.href.includes("localhost") ? "http://localhost:3030" : "https://tlb-heleket-payments-92780517083.europe-west1.run.app"
// const CRYPTO_URL = window.location.href.includes("localhost") ? "http://localhost:3030" : "https://toplistbot-cryptomus-payments-92780517083.europe-west1.run.app"

const GLOBAL_URLS = {
    CRYPTO_URL
}

export default GLOBAL_URLS
